<template>
  <div class="ios-container">
    <h1>iOS 页面</h1>
    <p>这是 iOS 专属页面</p>
    <button @click="redirect">跳转到外部网页</button>
  </div>
</template>

<script>
export default {
  name: 'iOSPage',
  methods: {
    redirect() {
      // 修改这里的URL为你想跳转的网页
      window.location.href = 'https://www.apple.com'
    }
  }
}
</script>

<style scoped>
.ios-container {
  padding: 20px;
  text-align: center;
}

h1 {
  color: #007aff;
  margin-bottom: 20px;
}

button {
  padding: 10px 20px;
  font-size: 16px;
  background-color: #007aff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 20px;
}

button:hover {
  background-color: #0051d5;
}
</style>
